import * as React from 'react';

import { cn } from '@epoch-ui/lib/utils';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, error, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          'tw-flex tw-min-h-[80px] tw-w-full tw-rounded-md tw-border-2 tw-border-solid tw-border-input tw-bg-background tw-px-3 tw-py-2 tw-text-sm tw-ring-offset-background placeholder:tw-text-muted-foreground focus-visible:tw-border-primary-blue focus-visible:tw-outline-none disabled:tw-cursor-not-allowed disabled:tw-opacity-50 md:tw-text-sm',
          error && 'tw-border-destructive-foreground',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Textarea.displayName = 'Textarea';

export { Textarea };
